import marketplace from 'cfg/marketplace.json';
import { MICROSOFT_UET_IFRAME_ID } from 'constants/appConstants';
import {
  CLEAR_STORED_MICROSOFT_UET_EVENTS,
  SET_MICROSOFT_UET_TAG_LOADED,
  STORE_MICROSOFT_UET_EVENT
} from 'constants/reduxActions';
import { logError } from 'middleware/logger';

export function clearStoredMicrosoftUetEvents() {
  return { type: CLEAR_STORED_MICROSOFT_UET_EVENTS };
}

export function setMicrosoftUetTagLoaded(loaded) {
  return {
    type: SET_MICROSOFT_UET_TAG_LOADED,
    loaded
  };
}

export function storeMicrosoftUetEvent(event) {
  return {
    type: STORE_MICROSOFT_UET_EVENT,
    event
  };
}

function doUncheckedPush(event) {
  const uetFrame = document.getElementById(MICROSOFT_UET_IFRAME_ID);
  if (!uetFrame) {
    logError('[msftUet] couldn\'t find iframe');
    return;
  }
  const { data, name = '' } = event;
  const payload = JSON.stringify({ microsoftUetTagEvent: { data, name } });
  uetFrame.contentWindow?.postMessage(payload, event.origin);
}

export function pushMicrosoftUetEvent(event) {
  return (dispatch, getState) => {
    const { microsoftUetTag: { loaded } } = getState();
    if (loaded) {
      doUncheckedPush(event);
    } else {
      dispatch(storeMicrosoftUetEvent(event));
    }
  };
}

export function pushStoredMicrosoftUetEvents() {
  return (dispatch, getState) => {
    const { microsoftUetTag: { events } } = getState();
    events.forEach(event => doUncheckedPush(event));
    dispatch(clearStoredMicrosoftUetEvents());
  };
}

function createBasicMicrosoftUetEvent(data, name = '', origin = marketplace.analytics.microsoft.uet.tagOrigin) {
  return { data, name, origin };
}

export function createViewHomePageMicrosoftUetEvent() {
  return createBasicMicrosoftUetEvent({ ecomm_pagetype: 'home' });
}

export function createViewSearchPageMicrosoftUetEvent(searchTerm, productIds) {
  return createBasicMicrosoftUetEvent({
    ecomm_pagetype: 'searchresults',
    ecomm_prodid: productIds,
    ecomm_query: searchTerm
  });
}

export function createViewProductPageMicrosoftUetEvent(productId) {
  return createBasicMicrosoftUetEvent({
    ecomm_pagetype: 'product',
    ecomm_prodid: [productId]
  });
}

/**
 * create a Microsoft UET event for adding a product to cart
 *
 * @param stockId   the ID of the product
 * @param price       the price of the product
 * @param addedFrom   the page the product was added to cart from (usually
 *                    "product", as in, "added from PDP")
 */
export function createAddToCartMicrosoftUetEvent(stockId, price, addedFrom) {
  return createBasicMicrosoftUetEvent({
    ecomm_pagetype: addedFrom,
    ecomm_prodid: stockId,
    ecomm_totalvalue: price,
    currency: 'USD'
  }, 'add_to_cart');
}

export function createViewCartPageMicrosoftUetEvent(stockIds, total, items) {
  return createBasicMicrosoftUetEvent({
    ecomm_prodid: stockIds,
    ecomm_pagetype: 'cart',
    ecomm_totalvalue: total,
    currency: 'USD',
    items
  });
}

/** Microsoft UET event for the order confirmation page */
export function createPurchaseMicrosoftUetEvent(stockIds, total, items) {
  return createBasicMicrosoftUetEvent({
    ecomm_prodid: stockIds,
    ecomm_pagetype: 'purchase',
    ecomm_totalvalue: total,
    currency: 'USD',
    items
  });
}

export function createMicrosoftUetEventProductEntry(stockId, price, quantity) {
  return {
    id: stockId,
    price,
    quantity
  };
}
